import { Club } from "../../../Lib";
import { FC, ReactNode, useEffect, useState } from "react";
import { Button, Col, Input, message, Row, Space, Typography } from "antd";
import { AppImagePreview, AppViewCard } from "../../../../../components";
import { TextField } from "@refinedev/antd";
import { dateFormat, DayMonthYear } from "../../../../../helpers";
import s from "./Clubs-Main-Info.module.scss";
import { ClubsChangeColor } from "../Clubs-Change-Color/Clubs-Change-Color";
import { ClubsBackground } from "../Clubs-Background/Clubs-Background";
import { ClubsChangeStadium } from "../Clubs-Change-Stadium/Clubs-Change-Stadium";
import { ClubsStadiumPhoto } from "../Clubs-Stadium-Photo/Clubs-Stadium-Photo";
import { addSlug } from "../../../Providers/clubs-add-slug-provider";
import { ClubsChangeMapCoordinates } from "../Clubs-Change-Map-Coordinates/Clubs-Change-Map-Coordinates";
import { ClubsChangeStadiumCapacity } from "../Clubs-Change-Stadium-Capacity/Clubs-Change-Stadium-Capacity";

const { Title } = Typography;

type ClubsMainInfoProps = Pick<
  Club,
  | "title"
  | "logoUrl"
  | "bday"
  | "stadium"
  | "stadiumId"
  | "stadiumCity"
  | "stadiumPhoto"
  | "stadiumCapacity"
  | "city"
  | "color"
  | "colorAlt"
  | "leagueId"
  | "teamId"
  | "mapX"
  | "mapY"
  | "hideMap"
  | "colorName"
  | "background"
  | "teamSlug"
> & { children: ReactNode; onRefetch: () => void };
export const ClubsMainInfo: FC<ClubsMainInfoProps> = ({
  bday,
  logoUrl,
  stadium,
  stadiumCity,
  stadiumPhoto,
  stadiumId,
  stadiumCapacity,
  title,
  city,
  color,
  colorAlt,
  colorName,
  children,
  leagueId,
  teamId,
  mapX,
  mapY,
  hideMap,
  onRefetch,
  background,
  teamSlug,
}) => {
  const [slug, setSlug] = useState(teamSlug);
  const transliterate = (text: string) => {
    const map: Record<string, string> = {
      а: "a",
      б: "b",
      в: "v",
      г: "g",
      д: "d",
      е: "e",
      ё: "yo",
      ж: "zh",
      з: "z",
      и: "i",
      й: "y",
      к: "k",
      л: "l",
      м: "m",
      н: "n",
      о: "o",
      п: "p",
      р: "r",
      с: "s",
      т: "t",
      у: "u",
      ф: "f",
      х: "h",
      ц: "ts",
      ч: "ch",
      ш: "sh",
      щ: "sch",
      ъ: "",
      ы: "y",
      ь: "",
      э: "e",
      ю: "yu",
      я: "ya",
    };

    return text
      .toLowerCase()
      .replace(/ь/g, "")
      .split("")
      .map((char) => map[char] || char)
      .join("")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .trim();
  };
  const generateSlug = () => {
    if (!title) return;

    const result = transliterate(title);
    setSlug(result);
  };
  const handleSaveSlug = async () => {
    try {
      await addSlug({ fnlId: teamSlug, slug });
      message.success("Slug успешно сохранён");
      onRefetch();
    } catch (error) {
      message.error(
        error instanceof Error ? error.message : "Не удалось сохранить slug"
      );
    }
  };
  useEffect(() => {
    if (!teamSlug) return;
    setSlug(teamSlug);
  }, [teamSlug]);
  return (
    <Space direction={"vertical"} size={16} style={{ width: "100%" }}>
      <Title level={5}>Основная информация</Title>
      <Row gutter={24}>
        <Col span={12}>
          <Space direction={"vertical"} style={{ width: "100%" }} size={24}>
            <AppViewCard label={"Название команды:"}>
              <TextField value={title} />
            </AppViewCard>
            <ClubsChangeColor
              color={{
                value: color,
                colorAlt: colorAlt,
                id: null,
                colorName: colorName,
              }}
              leagueId={leagueId}
              teamId={teamId}
              onRefetchCard={onRefetch}
            />
            <AppViewCard label={"Slug команды:"}>
              <Space>
                <Input
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  placeholder="team-slug"
                />

                <Button onClick={generateSlug}>Сгенерировать</Button>
                <Button onClick={handleSaveSlug}>Сохранить</Button>
              </Space>
            </AppViewCard>
            <AppViewCard label={"Город клуба:"}>
              <TextField value={city} />
            </AppViewCard>
            <ClubsChangeMapCoordinates
              leagueId={leagueId}
              teamId={teamId}
              mapX={mapX}
              mapY={mapY}
              hideMap={hideMap}
              onRefetchCard={onRefetch}
            />
            <AppViewCard label={"Дата основания:"}>
              <TextField value={bday ? dateFormat(bday, DayMonthYear) : "–"} />
            </AppViewCard>
            <ClubsChangeStadium
              leagueId={leagueId}
              teamId={teamId}
              stadiumId={stadiumId}
              stadiumCity={stadiumCity}
              stadium={stadium}
              onRefetchCard={onRefetch}
            />
            <ClubsChangeStadiumCapacity
              teamFnlId={teamSlug}
              stadiumCapacity={stadiumCapacity}
              onRefetchCard={onRefetch}
            />
          </Space>
        </Col>
        <Col span={12}>
          <div className={s.card}>
            <Space direction={"horizontal"} size={16}>
              <AppViewCard label={"Логотип клуба:"} sharedStyles={s.logo}>
                <AppImagePreview
                  sharedStyles={s.logo}
                  imageURL={logoUrl}
                  useS3
                />
              </AppViewCard>
              <ClubsBackground
                background={background}
                leagueId={leagueId}
                teamId={teamId}
                onRefetchCard={onRefetch}
              />
              <ClubsStadiumPhoto
                url={stadiumPhoto}
                leagueId={leagueId}
                stadiumId={stadiumId}
                onRefetchCard={onRefetch}
              />
            </Space>

            {children}
          </div>
        </Col>
      </Row>
    </Space>
  );
};
